"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderBar = void 0;
var _system = require("@mui/system");
var HeaderBar = exports.HeaderBar = (0, _system.styled)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 20,
    marginBottom: 10,
    padding: "8px 12px",
    backgroundColor: theme.palette.primary.main,
    alignItems: 'center'
  };
});